import { makeAPICall } from "../../utils/common";

export function commonActionDispatcher(obj) {
    return (dispatch) => {
      const params = {
        url: obj.url,
        dispatch,
        type: obj.type,
        headers: obj.headers,
        params: obj.params,
        callback: obj.callback,
        errCallback: obj.errCallback
      };
      makeAPICall(params);
    };
  }